import '@components/module-components/POSMap/pos-map.scss'
import {createSearchQuery, getParams, getQueryParams, translate} from '@src/helpers'
import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import VerificationLegendBadge from '@components/VerificationLegend/VerificationLegendBadge'
import VerifiedLabelMarkup from '@components/module-components/POSMap/helper/VerifiedLabelMarkup'
import {I_POS, ProcessData, VerifiedLabelMarkupProps} from '@components/module-components/POSMap/types'
import {ENV} from '@environments/environment'
import {setPreviousUrl} from '@redux/actions/navigatorAction'
import {useHistory, useLocation} from 'react-router-dom'

const {AWS_S3_FILE_UPLOAD, API_URL, GG_KEY, URL_WEBAPP} = ENV

export const ContentMarkerSingle: React.FC<VerifiedLabelMarkupProps> = ({poz}: I_POS) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()

  const onClickProcessV2 = useCallback((process: ProcessData): void => {
    try {
      if (!process.b2c_url) return
      const {brand} = getParams()
      const qs = createSearchQuery({...getQueryParams(process.b2c_url), brand})

      dispatch(
        setPreviousUrl({
          previous: {...location},
          query: {
            viewMode: 'mapView',
            process_position: process.custom_order
          }
        })
      )

      history.push(`/step-detail?${qs}`)
    } catch (e) {
      console.error(e)
    }
  }, [])

  return (
    <li className={'fib-process-markers-single '} style={{cursor: 'pointer'}} onClick={() => onClickProcessV2(poz)}>
      <h6>{translate(langData.localize, poz.process_manufacturer_name)}</h6>

      <div className={`d-flex align-items-center mb-1`}>
        <span
          className={`fib-process-markers-status process-status-${(poz.claimed_status || '').toLowerCase()}`}
          dangerouslySetInnerHTML={{__html: poz.custom_order}}
        />

        <span className={'ml-2'} dangerouslySetInnerHTML={{__html: poz.process_name}} />

        <VerificationLegendBadge poz={poz} status={poz.claimed_status?.toLocaleUpperCase()} />
      </div>

      <VerifiedLabelMarkup className={'mb-1'} poz={poz} />
    </li>
  )
}

export default ContentMarkerSingle
